export * from './CategoriaServiceAdapter'